import { render, staticRenderFns } from "./copyerDrawer.vue?vue&type=template&id=97d7e16e"
import script from "./copyerDrawer.vue?vue&type=script&lang=js"
export * from "./copyerDrawer.vue?vue&type=script&lang=js"
import style0 from "./copyerDrawer.vue?vue&type=style&index=0&id=97d7e16e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports